import {
  BANK_ACC_REQUESTING,
  GET_PROFILE_REQUESTING,
  SET_DEFAULT_REQUESTING,
} from './constants';
import {
  profileRequestSuccess,
  profileRequestError,
  bankAccRequestSuccess,
  bankAccRequestError,
  setDefaultRequestError,
  setDefaultRequestSuccess,
} from './actions';
import { all, takeLatest, put, call, select } from 'redux-saga/effects';
import { handleApiErrors } from '../../lib/api-errors';

import { getMessage } from '../../lib/selector';

const appUrl = `${process.env.REACT_APP_API_URL}`;

function handleRequest(request) {
  return request
    .then(handleApiErrors)
    .then((response) => response.json())
    .then((json) => json)
    .catch((error) => {
      throw error;
    });
}

function customerApi(data) {
  const url = `${appUrl}/CoreServlet.pt`;
  const request = fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    },
    body: JSON.stringify(data),
  });
  return handleRequest(request);
}

function* profileRequestFlow({ params }) {
  try {
    const resData = yield call(customerApi, params);

    if (resData.http !== 200) {
      if (resData.http === 401) {
        localStorage.removeItem('token');
        sessionStorage.removeItem('authen');

        yield put({ type: 'INVALID_SESSION', resData: resData.data.message });
      }
      const msgErr = yield select(getMessage, resData);
      throw Error(msgErr);
    }

    yield put(profileRequestSuccess(resData.data));
  } catch (error) {
    // console.log(error)
    yield put(profileRequestError(error));
  }
}

function* bankAccRequestFlow({ params }) {
  try {
    const resData = yield call(customerApi, params);

    if (resData.http !== 200) {
      if (resData.http === 401) {
        localStorage.removeItem('token');
        sessionStorage.removeItem('authen');

        yield put({ type: 'INVALID_SESSION', resData: resData.data.message });
      }
      const msgErr = yield select(getMessage, resData);
      throw Error(msgErr);
    }

    yield put(bankAccRequestSuccess(resData.data));
  } catch (error) {
    // console.log(error)
    yield put(bankAccRequestError(error));
  }
}

function* setDefaultRequestFlow({ params }) {
  try {
    const resData = yield call(customerApi, params);

    if (resData.http !== 200) {
      if (resData.http === 401) {
        localStorage.removeItem('token');
        sessionStorage.removeItem('authen');

        yield put({ type: 'INVALID_SESSION', resData: resData.data.message });
      }
      const msgErr = yield select(getMessage, resData);
      throw Error(msgErr);
    }

    yield put(setDefaultRequestSuccess(resData.data));
  } catch (error) {
    // console.log(error)
    yield put(setDefaultRequestError(error));
  }
}

function* customerWatcher() {
  yield all([
    takeLatest(GET_PROFILE_REQUESTING, profileRequestFlow),
    takeLatest(BANK_ACC_REQUESTING, bankAccRequestFlow),
    takeLatest(SET_DEFAULT_REQUESTING, setDefaultRequestFlow),
  ]);
}

export default customerWatcher;
